import { Controller } from "@hotwired/stimulus";

export default class Tinymce extends Controller {
  connect() {
    const id = this.element.id;
    const existingEditor = tinymce.get(id);
    if (existingEditor) {
      existingEditor.remove();
    }

    tinymce.init({
      selector: `#${id}`,
      license_key: "gpl",
      plugins: "lists link image table code help wordcount",
      content_style: `
        body { background-color: #000 !important; color: #fff !important; }
        .mce-content-body[data-mce-placeholder]:not(.mce-visualblocks)::before {
          color: #fff !important;
          opacity: .6;
        }
      `,
      toolbar:
        "undo redo | bold italic underline | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat"
    });
  }

  disconnect() {
    const editor = tinymce.get(this.element.id);
    if (editor) {
      editor.remove();
    }
  }
}
